import { PostHogProvider } from 'posthog-js/react'

import { POSTHOG_HOST, POSTHOG_KEY } from '@/config'

export default function TrackingProvider({
  children,
}: {
  children: React.ReactNode
}) {
  if (!POSTHOG_HOST || !POSTHOG_KEY) return <>{children}</>

  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={{ api_host: POSTHOG_HOST }}>
      {children}
    </PostHogProvider>
  )
}
